import React, { useMemo } from 'react';
import Popup from 'reactjs-popup'
import style from './emoji.module.css';
import AppState from 'store/app/app.state';
import { emojis } from './emojiList';
import classNames from 'classnames';

interface Props {
    disabled: boolean;
    config: AppState["emojisConfig"];
    onClickEmoji(emoji: string): void;
}

const Emoji: React.FC<Props> = ({ config, disabled, onClickEmoji }) => {

    const emojiList = useMemo(() => {
        return !!config?.blacklist
            ? emojis.filter(e => !config.blacklist?.includes(e))
            : config?.whitelist ?? emojis
    }, [config])

    return (
        <div
            className={classNames([style.wrapper])}>
            <Popup
                trigger={(
                    <button disabled={disabled} className={style.icon} type='button'>
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1707 6.82928C20.0265 9.68499 20.0265 14.315 17.1707 17.1707C14.315 20.0264 9.68502 20.0264 6.82931 17.1707C3.9736 14.315 3.9736 9.68499 6.82931 6.82928C9.68502 3.97357 14.315 3.97357 17.1707 6.82928ZM7.88997 7.88994C5.62005 10.1599 5.62005 13.8401 7.88997 16.1101C10.1599 18.38 13.8402 18.38 16.1101 16.1101C18.38 13.8401 18.38 10.1599 16.1101 7.88994C13.8402 5.62002 10.1599 5.62002 7.88997 7.88994ZM15.2419 13.0625C14.8242 13.8976 14.0969 14.545 13.2057 14.8593C11.4617 15.4744 9.56211 14.676 8.75761 13.0625H15.2419ZM9 9C9.55229 9 10 9.44772 10 10C10 10.5523 9.55229 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9ZM15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9Z" fill="#696969" />
                        </svg>

                    </button>
                )}
                position={['top left']}
                closeOnDocumentClick
                offsetY={-16}
            >
                <div className={style.tooltip}>
                    {emojiList.map(e => (
                        <button
                            onClick={() => onClickEmoji(e)}
                            type='button'
                            className={style.emoji}
                            key={e}>
                            {e}
                        </button>
                    ))}
                </div>
            </Popup>
        </div>
    )
}

export default Emoji;